<script setup>
import {
  HrDismissBtn, HrSuccessBanner, HrSupportingBtn, HrWarningBanner,
} from 'src/design-system';

defineOptions({ name: 'OfflineModeBanners' });

defineProps({
  warningVisible: { type: Boolean, default: false },
  successVisible: { type: Boolean, default: false },
  bannerClass: { type: [String, Object], default: '' },
});

const emit = defineEmits(['dismiss-warning', 'dismiss-success', 'switch-offline', 'switch-online']);
</script>

<template>
  <hr-warning-banner
    v-if="warningVisible"
    full-bleed
    :heading="$t('offlineBanner.warningTitle')"
    :message="$t('offlineBanner.warningMessage')"
    :class="bannerClass"
    data-e2e="banner-offline-warning"
  >
    <template #action>
      <hr-dismiss-btn
        :label="$t('common.buttonDismiss')"
        :legacy-props="{ flat: true, color: 'dark' }"
        @click="emit('dismiss-warning')"
      />
      <hr-supporting-btn
        :label="$t('offlineBanner.switchToOffline')"
        :legacy-props="{ flat: true, color: 'dark' }"
        data-e2e="button-switch-to-offline"
        @click="emit('switch-offline')"
      />
    </template>
  </hr-warning-banner>

  <hr-success-banner
    v-if="successVisible"
    full-bleed
    dismissable
    :heading="$t('offlineBanner.successTitle')"
    :message="$t('offlineBanner.successMessage')"
    :class="bannerClass"
    data-e2e="banner-online-success"
  >
    <template #action>
      <hr-dismiss-btn
        :label="$t('common.buttonDismiss')"
        :legacy-props="{ flat: true, color: 'dark' }"
        @click="emit('dismiss-success')"
      />
      <hr-supporting-btn
        :label="$t('offlineBanner.syncAndGoOnline')"
        :legacy-props="{ flat: true, color: 'dark' }"
        data-e2e="button-sync-and-go-online"
        @click="emit('switch-online')"
      />
    </template>
  </hr-success-banner>
</template>
